export const getIpRuleData = function (regionData) {
  const specilCity = '天津、北京、上海、重庆、香港、澳门';
  const ret = regionData.map((item) => {
    if (specilCity.indexOf(item[1]) > -1) {
      return [item[0], item[1], item[1], item[2]];
    }

    return item;
  });
  return ret;
};
export const getRegionText = function (regionData, allLocations, type = '') {
  if (allLocations.length === 0) {
    return [];
  }
  // 处理全选
  const provinceMap = {};
  const countryMap = {};
  const onlyTwoLevelMap = {};
  regionData.forEach((item) => {
    const key = `${item[0]}_${item[1]}`;
    if (provinceMap[key]) {
      // eslint-disable-next-line no-plusplus
      provinceMap[key]++;
    } else if (item.length === 2) {
      provinceMap[key] = -1;
    } else {
      provinceMap[key] = 1;
    }
  });
  Object.keys(provinceMap).forEach((provinceKey) => {
    const keys = provinceKey.split('_');
    const country = allLocations.find(obj => obj.value === keys[0]);
    const province = country.subs.find(obj => obj.value.split('@')[1] === keys[1]);
    if (province && province.subs.length === provinceMap[provinceKey]) {
      provinceMap[provinceKey] = -1;
    }
  });
  const selectAllProvince = Object.keys(provinceMap).filter(provinceKey => provinceMap[provinceKey] === -1);
  selectAllProvince.forEach((provinceKey) => {
    const countryKey = provinceKey.split('_')[0];
    if (countryMap[countryKey]) {
      // eslint-disable-next-line no-plusplus
      countryMap[countryKey]++;
    } else {
      countryMap[countryKey] = 1;
    }
  });
  Object.keys(countryMap).forEach((countryKey) => {
    const country = allLocations.find(obj => obj.value === countryKey);
    if (country.subs.length === countryMap[countryKey]) {
      countryMap[countryKey] = -1;
    }
  });
  // 保持顺序
  const filterData = [];
  regionData.forEach((item) => {
    if (countryMap[item[0]] === -1) {
      countryMap[item[0]] = -2;
      filterData.push([item[0]]);
      return;
    }
    if (countryMap[item[0]] === -2) {
      // 前面有相同的国家
      return;
    }
    // 国家没有全选，判断省

    const provinceKey = `${item[0]}_${item[1]}`;
    if (item.length === 2) {
      onlyTwoLevelMap[provinceKey] = 1;
    }
    if (provinceMap[provinceKey] === -1) {
      provinceMap[provinceKey] = -2;
      filterData.push([item[0], item[1]]);
      return;
    }
    if (provinceMap[provinceKey] === -2) {
      // 前面有相同的省
      return;
    }

    filterData.push(item);
  });

  // 返回中文
  const ret = filterData.map((item) => {
    const country = allLocations.find(obj => obj.value === item[0]);
    const province =            country
            && country.subs.find(obj => obj.value.split('@')[1] === item[1]);
    const city =            province
            && province.subs.find(obj => obj.value.split('@')[2] === item[2]);
    const formatData = [country.name];
    if (province) {
      const provinceKey = `${item[0]}_${item[1]}`;
      if (type === 'clientLib' && onlyTwoLevelMap[provinceKey]) {
        formatData.push(undefined);
      }
      formatData.push(province.name);
    }
    if (city) {
      formatData.push(city.name);
    }
    return formatData;
  });
  return ret;
};
